
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper }
	})
	export default class PrescriptionItemSelect extends PrescriptionItem {
		@PropSync('inputSelect', { required: true, default: '' }) inputSelectValue!: string;
		@Prop({ required: true }) selectValues!: {};
	}
